import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for auto-exclusion users table.
 * @extends JetView
 */
export default class tableAutoexclusionUsersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // Unique identifier for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling based on screen width
                            columns: [
                                {
                                    id: 'detailTittle', // Column identifier
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Detalles', // Tooltip text
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        if (devConfig.getPermAction('overrideSelfExclusion', 'Add')) {
                                            if (obj.State == 'A') {
                                                return "<span placeholder='Pagar' class='webix_icon wxi-close torefuse'></span>"; // Icon for refusal action
                                            } else {
                                                return '';
                                            }
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'detailTittle', // Duplicate column identifier (should be unique)
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Localized tooltip text
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details action
                                    },
                                },
                                {
                                    id: 'Id', // Column identifier
                                    header: 'Id', // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PlayerId', // Column identifier
                                    header: _('ID Usuario'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column identifier
                                    header: _('Usuario (Correo electrónico)'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: !devConfig.getPermAction('sensitiveInformationEmail', 'Add'), // Conditional visibility based on permissions
                                },
                                {
                                    id: 'State', // Column identifier
                                    header: _('Estado'), // Localized column header
                                    options: [
                                        // Dropdown options for the state column
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column identifier
                                    header: _('Tipo'), // Localized column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Product', // Column identifier
                                    header: _('Producto'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'StartDate', // Column identifier
                                    header: _('Fecha inicio de la autoexclusión'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 250, // Column width
                                    sort: 'text', // Sorting type
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Date formatting function
                                },
                                {
                                    id: 'FinalDate', // Column identifier
                                    header: _('Fecha final de la autoexclusión'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 250, // Column width
                                    sort: 'text', // Sorting type
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Date formatting function
                                },
                                {
                                    id: 'UserCreation', // Column identifier
                                    header: _('Usuario Creación'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserModified', // Column identifier
                                    header: _('Usuario Modificó'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ModifiedDate', // Column identifier
                                    header: _('Fecha de modificación'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 250, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting function
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                details: function (euv, id) {
                                    // Handler for details icon click
                                    let item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    if ($$('dColl').config.collapsed) {
                                        // Check if the details section is collapsed
                                        $$('dColl').expand(); // Expand the details section
                                    }
                                },
                                torefuse: function (euv, id) {
                                    // Handler for refusal icon click
                                    var vvthis = this; // Reference to the current instance
                                    webix // Create a confirmation window
                                        .ui({
                                            view: 'window',
                                            head: _('Desea anular la autoexclusión?'), // Window header
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                view: 'form', // Form component
                                                id: 'overrideForm', // Unique identifier for the form
                                                elements: [
                                                    {
                                                        view: 'text', // Text input for note
                                                        label: _('Nota'), // Localized label
                                                        labelPosition: 'top', // Label position
                                                        name: 'Note', // Input name
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        cols: [
                                                            // Button layout
                                                            {
                                                                view: 'button', // Cancel button
                                                                value: _('Cancelar'), // Localized button text
                                                                click: function (elementId, event) {
                                                                    // Click handler
                                                                    this.getTopParentView().hide(); // Hide the window
                                                                },
                                                            },
                                                            {
                                                                view: 'button', // Override button
                                                                value: _('Anular'), // Localized button text
                                                                click: function (elementId, event) {
                                                                    // Click handler
                                                                    const ethis = this; // Reference to the current instance
                                                                    var item = vvthis.getItem(id); // Get the item to override
                                                                    var values = $$('overrideForm').getValues(); // Get form values
                                                                    if ($$('overrideForm').validate()) {
                                                                        // Validate form
                                                                        webix // AJAX request to override self-exclusion
                                                                            .ajax()
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                    'Client/OverrideSelfExclusion',
                                                                                '{ "Id":' +
                                                                                    item.Id +
                                                                                    ',"Note":"' +
                                                                                    values.Note +
                                                                                    '"}',
                                                                                {
                                                                                    error: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        // Error handler
                                                                                        webix.message(_('Error! ')); // Show error message
                                                                                        this.getTopParentView().hide(); // Hide the window
                                                                                    },
                                                                                    success: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        // Success handler
                                                                                        var dat = JSON.parse(text); // Parse response
                                                                                        if (dat.HasError) {
                                                                                            // Check for errors
                                                                                            webix.message({
                                                                                                title: '¡Mensaje!', // Message title
                                                                                                type: 'alert-error', // Message type
                                                                                                text: _(
                                                                                                    dat.AlertMessage,
                                                                                                ), // Alert message
                                                                                            });
                                                                                            ethis
                                                                                                .getTopParentView()
                                                                                                .hide(); // Hide the window
                                                                                        } else {
                                                                                            item.State = 'C'; // Update item state
                                                                                            webix.message(
                                                                                                _(
                                                                                                    'Autoexclusión Anulada',
                                                                                                ),
                                                                                            ); // Show success message
                                                                                            vthis
                                                                                                .$$('datatable')
                                                                                                .refresh(); // Refresh the datatable
                                                                                            ethis
                                                                                                .getTopParentView()
                                                                                                .hide(); // Hide the window
                                                                                        }
                                                                                    },
                                                                                },
                                                                            );
                                                                    } else {
                                                                        webix.message({
                                                                            title: _('¡Mensaje!'), // Message title
                                                                            type: 'alert-error', // Message type
                                                                            text: _('Completa los campos...'), // Alert message
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                                elementsConfig: {
                                                    on: {
                                                        onChange: function () {
                                                            // Change event for validation
                                                            this.validate(); // Validate the form
                                                        },
                                                    },
                                                },
                                            },
                                            move: true, // Allow window movement
                                        })
                                        .show(); // Show the window
                                },
                            },
                            on: {
                                // Event handlers for DataTable events
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // When the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(_("<div style='margin:75px; font-size:18px;'>No hay datos</div>")); // Show no data overlay
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Preload data configuration
                            pager: 'pagerA', // Pager identifier
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        const wthis = this; // Reference to the current instance
        grid = $$('datatable'); // Get the DataTable instance
        var url = devConfig.geturlApi() + 'null/Report/getRegisteredAutoexclusion'; // API endpoint for loading data
        var filter = ''; // Filter string

        // Event listener for filtering data
        this.on(this.app, 'autoexclusionUsers:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter string
                    } else if (object[i][0] == 'Datepicker2') {
                        // Handle modified date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFromModified=' + date[0]; // Add start modified date to filter string
                        string1 = string1 + '&dateToModified=' + date[1]; // Add end modified date to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter string
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data filtered by PlayerId
            );
        });
    }
}

// FILE DOCUMENTED
